import React from 'react';
import TopNavigation from '../components/TopNavigation';

const Privacy: React.FC = () => {
  return (
    <div style={styles.container}>
      <TopNavigation />
      <div style={styles.contentArea}>
        <header style={styles.header}>
          <h1 style={styles.title}>Privacy Policy</h1>
          <p style={styles.subtitle}>How we collect, use, and protect your information.</p>
        </header>

        <section style={styles.section}>
          <h2 style={styles.h2}>Overview</h2>
          <p style={styles.p}>
            We respect your privacy. We collect information you provide (like your profile, posts, and messages) and
            information generated by your use of Belivah (like device data and interactions) to operate and improve the platform.
            We do not sell your personal information.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Data We Collect</h2>
          <ul style={styles.ul}>
            <li>Account data (name, username, email, profile photo)</li>
            <li>Content you create (posts, videos, stories, groups)</li>
            <li>Usage data (views, likes, follows, device type)</li>
            <li>Optional contacts or location data with your permission</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>How We Use Data</h2>
          <ul style={styles.ul}>
            <li>Provide and secure Belivah features</li>
            <li>Personalize content and recommendations</li>
            <li>Communicate updates and respond to support requests</li>
            <li>Comply with legal obligations and enforce our Terms</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Your Choices</h2>
          <ul style={styles.ul}>
            <li>Access, update, or delete your data in Settings</li>
            <li>Control notifications and privacy settings</li>
            <li>Report or block users and content that violate guidelines</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Data Security</h2>
          <p style={styles.p}>We use technical and organizational safeguards. No system is 100% secure, but we work to protect your data.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Contact</h2>
          <p style={styles.p}>Questions? Email privacy@belivah.com</p>
        </section>
      </div>
    </div>
  );
};

const styles: { [k: string]: React.CSSProperties } = {
  container: { display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--color-background-alt)' },
  contentArea: { paddingTop: '80px', maxWidth: '900px', margin: '0 auto', padding: '20px' },
  header: { background: '#0B6B6F', color: '#fff', padding: '20px 24px', borderRadius: 12 },
  title: { margin: 0, fontSize: 28 },
  subtitle: { margin: '6px 0 0 0', fontSize: 14 },
  section: { background: '#fff', borderRadius: 12, padding: 20, marginTop: 16, border: '1px solid var(--color-border)' },
  h2: { margin: '0 0 10px 0', color: '#072B2C', fontSize: 20 },
  p: { margin: 0, color: '#072B2C' },
  ul: { margin: '0 0 0 18px', color: '#072B2C' },
};

export default Privacy;
